<script setup>
import { ref, onMounted } from 'vue';
const formContainer = ref(null);

onMounted(() => {
  // форма в dev режиме не загружается, падает ошибка, которая влияет на тесты.
  if (process.env.NODE_ENV !== 'development') {
    const formScript = document.createElement('script');
    formScript.setAttribute('data-b24-form', 'inline/348/kbrnpu');
    formContainer.value.insertAdjacentElement('afterbegin', formScript);

    let timestamp = parseInt(Date.now()/180000);
    let loaderScript = document.createElement('script');
    loaderScript.async = true;

    loaderScript.src = `https://b24.tradesoft.ru/upload/crm/form/loader_348_kbrnpu.js?${timestamp}`;

    document.head.appendChild(loaderScript);
  }
})

const reserve = await queryContent('/reserve-place').findOne();
</script>

<template>
  <section id="reserve-section" class="reserve">
    <NuxtImg
      class="reserve__bg-1"
      src="/img/ReservePlace/bg-11.png"
      alt="Фон"
      loading="lazy"
      format="webp"
    />
    <NuxtImg
      class="reserve__bg-2"
      src="/img/ReservePlace/bg-2.png"
      alt="Фон"
      loading="lazy"
      format="webp"
    />
    <div class="container">
      <div class="reserve__row">
        <div ref="formContainer" class="reserve__form" />
        <div class="reserve__text">
          <h2 class="reserve__title text-50">{{ reserve.title }}</h2>
          <p class="reserve__subtitle text-32">
            {{ reserve.subtitle }}
          </p>
          <div class="reserve__label text-24">{{ reserve.label }}</div>
          <p class="reserve__date text-32">{{ reserve.date }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.reserve {
  padding: 64px 0;
  background: linear-gradient(227.11deg, #7F74FF 0%, #749BFF 50.5%, #75CCC2 100%);
  position: relative;

  @media (max-width: $large) {
    padding: 50px 0;
  }

  @media (max-width: $medium) {
    padding: 40px 0;
  }

  @media (max-width: $mobile) {
    padding: 36px 0;
  }

  &__bg-1 {
    position: absolute;
    top: 0;
    left: 0;
    max-width: 507px;

    @media (max-width: $medium) {
      display: none;
    }
  }

  &__bg-2 {
    position: absolute;
    bottom: 0;
    right: 0;
    max-width: 350px;

    @media (max-width: $medium) {
      display: none;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr 1.1fr;
    align-items: center;
    max-width: 1350px;
    gap: 157px;
    margin: auto;

    @media (max-width: $large) {
      max-width: 100%;
      gap: 116px;
    }

    @media (max-width: $medium) {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    @media (max-width: $mobile) {
      gap: 36px;
    }
  }

  &__title {
    color: white;
    margin-bottom: 28px;

    @media (max-width: $medium) {
      font-size: 28px;
      margin-bottom: 14px;
    }

    @media (max-width: $mobile) {
      font-size: 24px;
      margin-bottom: 20px;
    }
  }

  &__text {
    color: white;
    position: relative;
    z-index: 1;

    @media (max-width: $medium) {
      order: -1;
      display: flex;
      flex-direction: column;
    }
  }

  &__subtitle {
    color: white;
    margin-bottom: 40px;

    @media (max-width: $medium) {
      margin-bottom: 14px;
      font-size: 20px;
    }

    @media (max-width: $mobile) {
      margin-bottom: 22px;
      font-size: 18px;
    }
  }

  &__label {
    padding: 10px 24px;
    border: 2px solid #FFFFFF;
    border-radius: 0 15px;
    display: inline-flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 42px;

    @media (max-width: $medium) {
      width: fit-content;
      order: -1;
      margin-bottom: 36px;
      font-size: 18px;
      padding: 2px 8px;
    }

    @media (max-width: $mobile) {
      margin-bottom: 25px;
    }

    &::before {
      content: '';
      display: inline-block;
      border-radius: 100%;
      width: 10px;
      height: 10px;
      background-color: #FE6767;
    }
  }

  &__date {
    color: white;

    @media (max-width: $medium) {
      font-size: 20px;
    }

    @media (max-width: $mobile) {
      font-size: 18px;
    }
  }

  .b24-form-wrapper {
    border-radius: 30px;

    @media (max-width: $medium) {
      max-width: 610px;
    }

    @media (max-width: $mobile) {
      border-radius: 15px;
    }
  }

  .b24-form-control {
    border: none !important;
    background-color: transparent !important;
    border-bottom: 2px solid rgba(60, 66, 72, 0.25) !important;
    height: 60px !important;
    border-radius: 0 !important;
    padding-left: 0 !important;

    @media (max-width: $medium) {
      height: 48px !important;
    }
  }

  .b24-form-control-required {
    display: none !important;
  }

  .b24-form-field {
    margin-bottom: 24px;
  }

  .b24-form-btn-block {
    padding-top: 0;
  }

  .b24-form-btn {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 30px;
    padding: 19px 20px;
    margin-top: 4px;

    @media (max-width: $medium) {
      font-size: 16px;
      padding: 6px 20px;
      min-height: 48px !important;
    }
  }

  .b24-form-header {
    padding: 56px 72px 0;
    border: none;

    @media (max-width: $large) {
      padding: 48px 48px 0;
    }

    @media (max-width: $medium) {
      padding: 50px 40px 0;
    }

    @media (max-width: $mobile) {
      padding: 18px 24px 0;
    }
  }

  .b24-form-sign {
    display: none;
  }

  .b24-form-content {
    padding: 0 72px;
    margin-bottom: 24px;

    @media (max-width: $large) {
      padding: 0 48px;
    }

    @media (max-width: $medium) {
      padding: 0 40px;
    }

    @media (max-width: $mobile) {
      padding: 0 24px;
    }
  }

  .b24-form-recaptcha {
    padding: 0 72px 56px;
    margin: 0;

    @media (max-width: $large) {
      padding: 0 48px 48px;
    }

    @media (max-width: $medium) {
      padding: 0 40px 40px;
      margin-bottom: 24px;
    }

    @media (max-width: $mobile) {
      padding: 0 24px 24px;
    }
  }

  .b24-form-control-label {
    padding-left: 0 !important;
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 27px;
    color: var(--darkgrey-color);
    opacity: 1 !important;
    top: 0px !important;

    @media (max-width: $medium) {
      font-size: 16px;
    }
  }

  .b24-form-control-container {
    display: flex;
    align-items: flex-start;

    input[type="checkbox"] {
      opacity: 0;
      position: absolute;

      &:checked +  .b24-form-control-desc {
        &::before {
          border-color: var(--dark-color);
          background-image: url('assets/images/svg/form-check.svg');
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }

  .b24-form-control-desc {
    opacity: 1 !important;
    display: flex;
    gap: 18px;

    &::before {
      content: '';
      display: block;
      flex: 0 0 32px;
      height: 32px;
      border: 2px solid rgba(60, 66, 72, 0.5);
      border-radius: 4px;

      @media (max-width: $medium) {
        flex: 0 0 28px;
        height: 28px;
      }
    }
  }

  .b24-form-header-title {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 124%;
    color: var(--dark-color);
    text-align: left;
    margin-bottom: 26px;
    max-width: 360px;
    position: relative;

    @media (max-width: $large) {
      font-size: 34px;
      max-width: 340px;
      margin-bottom: 33px;
    }

    @media (max-width: $medium) {
      font-size: 24px;
      margin-bottom: 24px;
      max-width: 100%;
    }

    &::before {
      content: '';
      position: absolute;
      right: 0;
      background-image: url("assets/images/svg/calendar-2.svg");
      background-repeat: no-repeat;
      background-position: center right;
      width: 65px;
      height: 59px;
      top: 50%;
      transform: translate(107%, -50%);

      @media (max-width: $large) {
        transform: translate(127%, -50%);
      }

      @media (max-width: $medium) {
        width: 54px;
        height: 48px;
        background-size: 54px 48px;
        transform: translate(5%, -50%);
      }

      @media (max-width: $mobile) {
        display: none;
      }
    }
  }

  .b24-form-field-agreement {
    margin-top: 12px;
  }

  .b24-form-field-agreement-link {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 19px !important;
    color: var(--dark-color);
    position: relative;
    top: -2px;
    left: 3px;
  }
}
</style>
